import styled from 'styled-components';

import {
  AboutUs,
  Reviewed,
  Services,
  Technologies,
  FooterDetails,
  ContactUs,
} from './partials';
import { device } from '../../constants';

const Footer = () => (
  <>
    <FooterContainer>
      <FooterSection>
        <ContactUs />
      </FooterSection>
      <FooterSection>
        <Services />
      </FooterSection>
      <FooterSection>
        <Technologies />
      </FooterSection>
      <FooterSection>
        <AboutUs />
      </FooterSection>
      <FooterSection>
        <Reviewed />
      </FooterSection>
    </FooterContainer>
    <FooterDetailsContainer>
      <FooterDetailsWrapper>
        <FooterDetails />
      </FooterDetailsWrapper>
    </FooterDetailsContainer>
  </>
);

const FooterContainer = styled.div`
  display: flex;
  padding: 60px 0;
  justify-content: space-between;
  @media screen and ${device.md} {
    flex-direction: column;
    gap: 10px;
  }
`;

const FooterSection = styled.div`
  box-sizing: border-box;
  text-align: center;
  @media screen and ${device.md} {
    padding: 10px;
  }
`;

const FooterDetailsContainer = styled.div`
  padding-bottom: 40px;
  box-sizing: border-box;
  text-align: center;
`;

const FooterDetailsWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  text-align: center;
`;

export { Footer };

Footer.displayName = 'Footer';
